// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "HeroForm-module--section--8K5Y-";
export var container = "HeroForm-module--container--3s3XE";
export var title = "HeroForm-module--title--19Wvo";
export var content = "HeroForm-module--content--2wqWV";
export var blockContainer = "HeroForm-module--blockContainer--_nYSj";
export var block = "HeroForm-module--block--1ZU01";
export var infoBlock = "HeroForm-module--infoBlock--tn7mp";
export var helperText = "HeroForm-module--helperText--20r4n";
export var submitButton = "HeroForm-module--submitButton--16BF4";
export var disabled = "HeroForm-module--disabled--3a4g2";
export var formSubmitting = "HeroForm-module--formSubmitting--2-z3Q";
export var formMessage = "HeroForm-module--formMessage--ZSx8H";
export var formMessageError = "HeroForm-module--formMessageError--3Qsmq";
export var input = "HeroForm-module--input--2l_s7";
export var textInput = "HeroForm-module--textInput--1HYQ3";
export var checkboxInput = "HeroForm-module--checkboxInput--2VLOD";
export var select = "HeroForm-module--select--87wln";
export var thankYouScreenContainer = "HeroForm-module--thankYouScreenContainer--sG1xd";
export var thankYouTitle = "HeroForm-module--thankYouTitle--2mizk";
export var thankYouText = "HeroForm-module--thankYouText--tz3eP";